// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FIN_TP_TAX_CONVERT = {
  PTAXDataEmissaoDocumentoEntrada: 'FIN_TP_TAX_CONVERT1',
  TaxaSiscomex: 'FIN_TP_TAX_CONVERT2',
  PTAXDataDesembaraco: 'FIN_TP_TAX_CONVERT3',
  PTAXDataFatoGerador: 'FIN_TP_TAX_CONVERT4',
  PTAXEmissaoTituloFinanceiro: 'FIN_TP_TAX_CONVERT5',
  PTAXEmissaoOrdemDeCompra: 'FIN_TP_TAX_CONVERT6',
  PTAXEmissaoPurchaseOrder: 'FIN_TP_TAX_CONVERT7',
  PTAXDataMovimentoBancario: 'FIN_TP_TAX_CONVERT8',
  PTAXEmissaoPedidoVenda: 'FIN_TP_TAX_CONVERT9',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FIN_TP_TAX_CONVERT1: 1,
    FIN_TP_TAX_CONVERT2: 2,
    FIN_TP_TAX_CONVERT3: 3,
    FIN_TP_TAX_CONVERT4: 4,
    FIN_TP_TAX_CONVERT5: 5,
    FIN_TP_TAX_CONVERT6: 6,
    FIN_TP_TAX_CONVERT7: 7,
    FIN_TP_TAX_CONVERT8: 8,
    FIN_TP_TAX_CONVERT9: 9
  }
}
